<a class="btn-scroll-top-mobile" aria-label="Volver arriba" (click)="scrollToElement('top')">
  <img src="./assets/images/top-mobile.png" width="30px">
  <img src="./assets/images/logo2.svg" width="30px">
</a>

